import { FileStatus } from '~/store/resource/resource.type';
import {
  BASE_BUTTON_COLOR,
  BASE_BUTTON_VARIANT,
} from '~/components/Global/Button';

export const getBookCardTitle = ({
  status,
  progress,
}: {
  status: FileStatus;
  progress?: number;
}) => {
  switch (status) {
    case FileStatus.progressing:
      return '下載中';
    case FileStatus.completed:
      return '下載完成';
    case FileStatus.paused:
      return '下載暫停';
    case FileStatus.installing:
      return progress === 100 ? '安裝成功' : '安裝中';
    default:
      return '';
  }
};

export const getBookCardActionButtonProps = (status: FileStatus) => {
  switch (status) {
    case FileStatus.progressing:
      return {
        variant: BASE_BUTTON_VARIANT.OUTLINED,
        color: BASE_BUTTON_COLOR.DOWNLOAD,
        text: '暫停',
        width: '96px',
      };
    case FileStatus.paused:
      return {
        variant: BASE_BUTTON_VARIANT.FILLED,
        color: BASE_BUTTON_COLOR.CONTINUE,
        text: '繼續',
        width: '96px',
      };
    case FileStatus.finish:
      return {
        variant: BASE_BUTTON_VARIANT.GHOST,
        color: BASE_BUTTON_COLOR.SUCCESS,
        text: '開啟',
        width: '100%',
      };
    case FileStatus.non:
    case FileStatus.cancel:
      return {
        variant: BASE_BUTTON_VARIANT.GHOST,
        color: BASE_BUTTON_COLOR.PRIMARY,
        text: '下載',
        width: '100%',
      };
    default:
      return {
        variant: BASE_BUTTON_VARIANT.GHOST,
        color: BASE_BUTTON_COLOR.SECONDARY,
        text: '',
      };
  }
};

const WEB_READER_BASE_URL = String(
  import.meta.env.VITE_READER_DOMAIN || 'https://reader.nani.com.tw',
).replace(/\/$/, '');

export const getWebReaderUrl = (bookId: string) =>
  `${WEB_READER_BASE_URL}/${bookId}`;

export const WEB_READER_ACTION_BUTTON_PROPS = {
  variant: BASE_BUTTON_VARIANT.GHOST,
  color: BASE_BUTTON_COLOR.SUCCESS,
  text: '開啟',
  width: '100%',
};

export const installableFileFormats = ['zip', 'iso'];
